import { store } from 'Store';

export const addImposterToUrl = (
  baseUrl: string,
  addQuestionMark?: boolean
) => {
  const isAdmin = store.getState().imposter.isAdmin;
  if (!isAdmin) {
    return baseUrl;
  }
  const imposterId = store.getState().imposter.imposterId;
  let url = baseUrl;
  if (imposterId) {
    url = `${baseUrl}${addQuestionMark ? '?' : '&'}isrId=${imposterId}`;
  }
  return url;
};
